import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';


export const ArrowPopper = styled(Box)`
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 16px;
  background-color: #fff;
  box-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
`;

export const PopperContent = styled(Box)`
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  max-width: 300px;
  padding: 16px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #e6e6e6;
  margin-top: 4px;
`;
